import {combineReducers} from 'redux'
import {connectRouter} from 'connected-react-router'
import {History} from 'history'
import {reducer as app} from './modules/app'
import {reducer as auth} from './modules/auth'
import {reducer as actions} from './modules/actions'
import {reducer as actionTypes} from './modules/actionTypes'
import {reducer as equipment} from './modules/equipment'
import {reducer as bodyAreas} from './modules/bodyAreas'
import {reducer as users} from './modules/users'
import {reducer as routines} from './modules/routines'
import {reducer as activities} from './modules/activities'
import {reducer as goals} from './modules/goals'

export type RootState = ReturnType<ReturnType<typeof createRootReducer>>
const createRootReducer = (history: History) =>
  combineReducers({
    router: connectRouter(history),
    app,
    auth,
    actions,
    actionTypes,
    equipment,
    bodyAreas,
    users,
    routines,
    activities,
    goals,
  })

export default createRootReducer
